var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompactYml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2H11V4H9V6H11V8H9V10H11V18H7V12H9V10H7V8H9V6H7V4H9V2H6ZM13 4L18 9H13V4Z",
    fill: "#5D616C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H10V17H8V15Z",
    fill: "#5D616C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.992 13.894L13.263 15.304V16H12.75V15.304L12.021 13.894H12.603L13.011 14.776L13.416 13.894H13.992ZM16.7337 13.894V16H16.2207V14.737L15.7497 16H15.3357L14.8617 14.734V16H14.3487V13.894H14.9547L15.5457 15.352L16.1307 13.894H16.7337ZM17.7656 15.604H18.4376V16H17.2526V13.894H17.7656V15.604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactYml);
export default __webpack_public_path__ + "static/media/Compact_YML.38f60820a945f7f7bf3fd97489e461a5.svg";
export { ForwardRef as ReactComponent };